import React, { useEffect, useState, useCallback } from "react";
import { PixelStyle } from "../../components/layout";
import { 
  TabButton, 
  ConfirmationModal, 
  AlertModal, 
  ButtonLoader, 
  TopScreenLoader
} from "../../components";
import { Td, Tr } from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { FiEdit3 } from "react-icons/fi";
import { SecurityReportList } from "./userList";
import { IoCaretUp, IoCaretDown } from "react-icons/io5";
import moment from "moment";
import { API_URL } from "../../apis/apiurl";
import axios from "axios";
import CardPopModel from "../../components/model/cardModel";
import {
  DocumentExportFormatDate,
} from "./viewManagementReport";
import { Eye, FileUp, LoaderCircle, Trash } from "lucide-react";
import { TOKEN_KEY } from "../../config/variable";
import {
  MultiTempDelete,
  RetrieveDeletedReportAPI,
  TempDeleteAPI,
  MultiDelete,
} from "../../apis/index.js";
import { VscDebugRestartFrame } from "react-icons/vsc";
import { SiGmail } from "react-icons/si";
import EmailFormModal from "../../components/EmailFormModal";
import { SavedUser } from "../../config/storage/index.js";
import createNewReport from "../../apis/createReport.js";
import Button from "../../components/ButtonX.js";
import Pagination from "../../components/Pagination";

// import { DocumentConfigurator } from "./viewManagementReport";

const ManagementReport = () => {
  const [reportTemplates, setReportTemplates] = useState([]);
  const [showReportData, setShowReportData] = useState("");
  const [searchTemplate, setSearchTemplate] = useState("");
  const [templateSearchTerm, setTemplateSearchTerm] = useState("");
  const [mixedData, setMixedData] = useState([]);
  const [activeTab, setActiveTab] = useState("active");
  const [templateList, setTemplateList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [reportTemplateId, setReportTemplateId] = useState("");
  const [showTemplateDropdown, setShowTemplateDropdown] = useState(false);
  const [isTemplateDropdownVisible, setTemplateDropdownVisible] = useState(false);
  const [firstCreateAt, setFirstCreateAt] = useState(null);
  const [lastCreateAt, setLastCreateAt] = useState(null);
  
  
  // Pagination state
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 50,
    totalItems: 0,
  });

  console.log("activeTabactiveTab", activeTab);
  const TableHead = [
    ...(activeTab === "templates" ? [] : ["checkbox"]),
    ...(activeTab === "templates" ? [] : ["Actions"]),
    ...(activeTab === "retrieve" ? "" : []),
    ...(activeTab === "templates" ? "" : []),
    "Company name",
    "Location",
    "Report name",
    ...(activeTab === "templates" ? [] : ["Date created"]),
    ...(activeTab === "submitted" ? ["Submitted by"] : []),
    ...(activeTab === "submitted" ? ["Time submitted"] : []),
    ...(activeTab === "retrieve" ? ["Deleted by"] : []),
    ...(activeTab === "retrieve" ? ["Deleted at"] : []),
    ...(activeTab === "templates" ? ["Actions"] : []),
  ];

  const headerFieldMapping = {
    "Company name": "companyName",
    Location: "companyLocation",
    "Report name": "template",
    "Date created": "createdAt",
    Status: "status",
  };


  // useEffect(() => {
  //   GetUserList().then((userList) => {
  //     const filerType = userList.filter((user) => user.type === "Client");
  //     setUsers(filerType);
  //   });

  //   const reportTemplatesRef = ref(database, "reportTemplates");
  //   const clientLocationsRef = ref(database, "clientLocations");

  //   get(clientLocationsRef)
  //     .then((snapshot) => {
  //       if (snapshot.exists()) {
  //         const data = snapshot.val();
  //         const clientLocationsData = Object.keys(data).map((key) => ({
  //           id: key,
  //           ...data[key],
  //         }));
  //         setClientLocations(clientLocationsData);
  //       } else {
  //         setClientLocations([]); // Set to an empty array if no locations found
  //         // // // console.log("No client locations found");
  //       }
  //     })
  //     .catch((error) => {
  //       setClientLocations([]); // Set to an empty array on error
  //       // // console.error(`Error fetching client locations: ${error.message}`);
  //     });

  //   get(reportTemplatesRef)
  //     .then((snapshot) => {
  //       if (snapshot.exists()) {
  //         const data = snapshot.val();
  //         const templatesArray = Object.keys(data).map((key) => ({
  //           id: key,
  //           ...data[key],
  //         }));
  //         setReportTemplates(templatesArray);
  //         // // // // console.log(templatesArray);
  //       } else {
  //         setMessage("No report templates found");
  //       }
  //     })
  //     .catch((error) => {
  //       setMessage(`Error fetching report templates: ${error.message}`);
  //     });

  //   //
  // }, []);

  const fetchSecurityReports = useCallback(async () => {
    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Loading reports...");
      setIsLoadingReports(true);
      const reports = await SecurityReportList();
      console.log("reports comes from the api", reports);
      setReportTemplates(reports);
    } catch (error) {
      console.log(error);
      showError("Failed to fetch reports. Please try again.");
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setIsLoadingReports(false);
    }
  }, []);
  useEffect(() => {
    fetchSecurityReports();
  }, [fetchSecurityReports]);

  const getClientList = async () => {
    try {
      const TOKEN = SavedUser?.token;
      const response = await axios.post(
        `${API_URL}/graphql`,
        {
          query:
            "query GetUserClientList { getUserClientList { company city zipCode address state industry clientName clientType streetAddress id } }",
          variables: {},
        },
        {
          headers: {
            Authorization: TOKEN,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data?.data?.getUserClientList || [];
      setClientList(data);
    } catch (error) {
      setClientList([]);
      console.log(error);
    }
  };

  const getTemplate = async () => {
    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Loading templates...");
      setIsLoadingTemplates(true);
      const TOKEN = SavedUser?.token;
      const response = await axios.post(
        `${API_URL}/graphql`,
        {
          query: `query GetTemplateListByToken { getTemplateListByToken { success data} }`,
          variables: {},
        },
        {
          headers: {
            Authorization: TOKEN,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response ooppopo", response);
      const data = response.data?.data?.getTemplateListByToken?.data || [];
      setTemplateList(data);
    } catch (error) {
      setTemplateList([]);
      showError("Failed to fetch templates. Please try again.");
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setIsLoadingTemplates(false);
    }
  };

  useEffect(() => {
    getClientList();
  }, []);

  useEffect(() => {
    getTemplate();
    // eslint-disable-next-line
  }, []);


  console.log("selectedTemplate", selectedTemplate);

  const handleTemplateClick = async (templateId) => {
    try {
      console.log("Creating report with template ID:", templateId);
      const response = await createNewReport(templateId);
      console.log("Full response of create new report:", response);

      // Check if the response has the expected structure
      if (response && response.success) {
        console.log("Report created successfully!");

        // Handle the data field - it could be an array, object, or direct value
        let reportId = null;
        if (response.data) {
          if (Array.isArray(response.data)) {
            reportId = response.data[0]?.id || response.data[0];
          } else if (typeof response.data === "object") {
            reportId = response.data.id || response.data;
          } else {
            reportId = response.data;
          }
        }

        if (reportId) {
          console.log("Report ID:", reportId);
          // Navigate to the created report's page
          window.location.href = `/report/${reportId}`;
        } else {
          console.log(
            "Report created but no report ID in response data:",
            response.data
          );
          showAlert(
            "Report created successfully but no report ID returned.",
            "success"
          );
        }
      } else {
        console.log("Report creation failed. Response:", response);
        showError(
          `Failed to create report: ${response?.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error creating report:", error);
      console.error("Error details:", error.response?.data || error.message);
      showError(
        `An error occurred while creating the report: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  // const SearchfilteredTemplates = reportTemplates.filter((template) =>
  //   template.name.toLowerCase().includes(searchTemplate.toLowerCase())
  // );

  // // console.log("SearchfilteredTemplates", SearchfilteredTemplates);

  const handleSelect = (templateId, templateName, templateLocation) => {
    // // console.log(
    //   "templateId, templateName, templateLocation",
    //   templateId,
    //   templateName,
    //   templateLocation
    // );
    setReportTemplateId(templateId);
    if (searchTemplate) {
      setSearchTemplate(templateName); // Update the search input with the selected template name
    }
    if (templateSearchTerm) {
      setTemplateSearchTerm(templateName);
      setShowReportData({
        ...showReportData,
        companyLocation: templateLocation,
      });
      // // // console.log("templateName",templateName)
    }
    setTemplateDropdownVisible(false);
    setShowTemplateDropdown(false); // Hide the dropdown after selection
  };
  const [generatedReports, setGeneratedReports] = useState([]);

  // useEffect(() => {
  //   const reportTemplatesRef = ref(database, "reportTemplates");
  //   // Fetch data from Firebase Realtime Database
  //   get(reportTemplatesRef)
  //     .then((snapshot) => {
  //       if (snapshot.exists()) {
  //         const data = snapshot.val();
  //         const templatesArray = Object.keys(data).map((key) => ({
  //           id: key,
  //           ...data[key],
  //         }));
  //         setReportTemplates(templatesArray);
  //       } else {
  //         setMessage("No report templates found");
  //       }
  //     })
  //     .catch((error) => {
  //       setMessage(`Error fetching report templates: ${error.message}`);
  //     });
  // }, []);

  // const fetchGeneratedReports = async () => {
  //   try {
  //     const snapshot = await get(generatedReportRef);
  //     if (snapshot.exists()) {
  //       const data = snapshot.val();
  //       const reportsArray = Object.keys(data).map(async (key) => {
  //         const userId = data[key].userId;
  //         const userSnapshot = await get(ref(database, `users/${userId}`));
  //         if (userSnapshot.exists()) {
  //           const userData = userSnapshot.val();
  //           return {
  //             id: key,
  //             ...data[key],
  //             user: userData,
  //           };
  //         } else {
  //           // // console.log(`User with ID ${userId} not found`);
  //           return {
  //             id: key,
  //             ...data[key],
  //           };
  //         }
  //       });
  //       const resolvedReports = await Promise.all(reportsArray);
  //       setGeneratedReports(resolvedReports);
  //       MergeDataHandler(resolvedReports);
  //     } else {
  //       // // console.log("No generated reports found");
  //     }
  //   } catch (error) {
  //     // console.error("Error fetching generated reports:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchGeneratedReports();
  // }, [reportTemplates]);

  // useEffect(() => {
  //   const data = [];
  //   if (reportTemplates && reportTemplates.length > 0) {
  //     reportTemplates.forEach((item) => {
  //       const reportName = reportTemplates.find(
  //         (template) => template.id === item.reportTemplatesId
  //       );
  //       // Merge properties of `item` and `reportName`
  //       if (reportName) {
  //         data.push({ ...reportName, ...item });
  //       } else {
  //         // data.push({ ...item }); // If no match, include item only
  //       }
  //     });
  //     // console.log("generatedReports", generatedReports);
  //   }

  //   setMixedData(data);
  // }, [generatedReports, reportTemplates]);

  const MergeDataHandler = () => {};

  // // // console.log("generatedReports", generatedReports);
  // // // console.log("reportTemplates", reportTemplates);
  // // // console.log("showReportData", showReportData);

  const [filteredData, setFilteredData] = useState([]);

  // Search Client Name
  // const [filterClientName, setFilterClientName] = useState([]);
  // useEffect(() => {
  //   const filteredClients = clientLocations
  //     ? clientLocations.filter(
  //         (client) =>
  //           client.clientName &&
  //           client.clientName.toLowerCase().includes(clientName.toLowerCase())
  //       )
  //     : [];
  //   setFilterClientName(filteredClients);
  //   // // console.log("Filtered Clients", filteredClients);
  // }, [clientName]);

  const [filters, setFilters] = useState({
    company: "",
    location: "",
    name: "",
    createdAt: "",
    status: "",
    isSubmitted: "",
    isSubmittedByManagement: "",
    deletedBy: "",
  });
  const [sortedReports, setSortedReports] = useState([]);
  const [sortedTemplates, setSortedTemplates] = useState([]);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null); // "asc" or "desc"

  // Date filter state
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Update pagination total items when active tab or data changes
  useEffect(() => {
    if (activeTab === "templates") {
      setPagination(prev => ({
        ...prev,
        totalItems: sortedTemplates.length,
        currentPage: 1, // Reset to first page when switching tabs
      }));
    } else {
      setPagination(prev => ({
        ...prev,
        totalItems: sortedReports.length,
        currentPage: 1, // Reset to first page when switching tabs
      }));
    }
  }, [activeTab, sortedTemplates.length, sortedReports.length]);

  const [selectedClientNameId, setSelectedClientNameId] = useState("");
  const [openSearchBarClientName, setOpenSearchBarClientName] = useState(false);

  // // console.log("generatedReports", generatedReports);
  // // console.log("reportTemplates", reportTemplates);

  console.log("reportTemplates", reportTemplates);

  const formattedDate = (timestamp) => {
    return timestamp
      ? moment(timestamp).format("MM/DD/YYYY hh:mm a")
      : "Invalid date";
  };

  useEffect(() => {
    // Ensure reportTemplates is valid
    if (!reportTemplates || !Array.isArray(reportTemplates)) {
      console.log("reportTemplates is invalid or empty:", reportTemplates);
      setSortedReports([]);
      return;
    }

    let filteredReports = reportTemplates.filter((item) => {
      // Apply activeTab filtering first
      let matchesActiveTab = true;
      if (activeTab === "submitted") {
        matchesActiveTab = !item.isDeleted && item.isSubmitted;
      } else if (activeTab === "retrieve") {
        matchesActiveTab = item.isDeleted;
      } else if (activeTab === "active") {
        matchesActiveTab = !item.isDeleted && !item.isSubmitted;
      }

      if (!matchesActiveTab) return false;

      // Safeguard against undefined/null values
      const isSubmittedFilter = filters.isSubmitted?.toLowerCase() || "";
      const isSubmittedByManagementFilter =
        filters.isSubmittedByManagement?.toLowerCase() || "";

      // Apply text filters
      const matchesTextFilters =
        (filters.name === "" ||
          item.template?.toLowerCase().includes(filters.name.toLowerCase())) &&
        (filters.company === "" ||
          item.companyName
            ?.toLowerCase()
            .includes(filters.company.toLowerCase())) &&
        (filters.location === "" ||
          item.companyLocation
            ?.toLowerCase()
            .includes(filters.location.toLowerCase())) &&
        (filters.createdAt === "" ||
          formattedDate(item.createdAt)
            ?.toLowerCase()
            .includes(filters.createdAt.toLowerCase())) &&
        (filters.status === "" ||
          item.status?.toLowerCase().includes(filters.status.toLowerCase())) &&
        (isSubmittedFilter === "" ||
          (isSubmittedFilter.startsWith("s") && (item.isSubmitted ?? false)) ||
          (isSubmittedFilter.startsWith("n") &&
            !(item.isSubmitted ?? false))) &&
        (isSubmittedByManagementFilter === "" ||
          (isSubmittedByManagementFilter.startsWith("s") &&
            (item.isSubmittedByManagement ?? false)) ||
          (isSubmittedByManagementFilter.startsWith("n") &&
            !(item.isSubmittedByManagement ?? false))) &&
        (filters.deletedBy === "" ||
          item.deletedBy
            ?.toLowerCase()
            .includes(filters.deletedBy.toLowerCase()));

      // Apply date range filter if both dates are set
      let matchesDateRange = true;
      if (fromDate && toDate) {
        const formattedFromDate = moment(fromDate, "YYYY-MM-DD");
        const formattedToDate = moment(toDate, "YYYY-MM-DD");
        const reportDate = moment(item.createdAt);
        matchesDateRange =
          reportDate.isSameOrAfter(formattedFromDate, "day") &&
          reportDate.isSameOrBefore(formattedToDate, "day");
      } else if (fromDate) {
        // If only fromDate is set, filter from that date onwards
        const formattedFromDate = moment(fromDate, "YYYY-MM-DD");
        const reportDate = moment(item.createdAt);
        matchesDateRange = reportDate.isSameOrAfter(formattedFromDate, "day");
      } else if (toDate) {
        // If only toDate is set, filter up to that date
        const formattedToDate = moment(toDate, "YYYY-MM-DD");
        const reportDate = moment(item.createdAt);
        matchesDateRange = reportDate.isSameOrBefore(formattedToDate, "day");
      }

      return matchesTextFilters && matchesDateRange;
    });

    console.log("Filtered Reports:", filteredReports);

    if (sortField) {
      const sorted = [...filteredReports].sort((a, b) => {
        let aValue = a[sortField];
        let bValue = b[sortField];

        // Handle date fields
        if (sortField === "createdAt") {
          aValue = new Date(aValue || 0).getTime();
          bValue = new Date(bValue || 0).getTime();
        } else {
          // Handle string fields
          aValue = (aValue || "").toString().toLowerCase();
          bValue = (bValue || "").toString().toLowerCase();
        }

        if (sortOrder === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else {
          return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
        }
      });
      console.log("Sorted Reports:", sorted);
      setSortedReports(sorted);
    } else {
      // Default Sort: Client (Asc) -> Date Created (Desc)
      const defaultSorted = [...filteredReports].sort((a, b) => {
        // 1. Sort by Client (companyName)
        const clientA = (a.companyName || "").toString().toLowerCase();
        const clientB = (b.companyName || "").toString().toLowerCase();

        if (clientA < clientB) return -1;
        if (clientA > clientB) return 1;

        // 2. If Clients are same, sort by Date Created (Desc)
        const dateA = new Date(a.createdAt || 0).getTime();
        const dateB = new Date(b.createdAt || 0).getTime();

        return dateB - dateA;
      });
      setSortedReports(defaultSorted);
    }
  }, [filters, reportTemplates, sortField, sortOrder, fromDate, toDate, activeTab]);

  // Filter and sort templates for templates tab
  useEffect(() => {
    if (activeTab !== "templates") return;
    
    // Ensure templateList is valid
    if (!templateList || !Array.isArray(templateList)) {
      setSortedTemplates([]);
      return;
    }

    let filteredTemplates = templateList.filter((template) => {
      // Get full location string for matching
      const fullLocation = `${template?.company?.address || ""}, ${template?.company?.city || ""}, ${template?.company?.state || ""} ${template?.company?.zipCode || ""}`.trim();
      
      // Apply text filters
      const matchesCompany = 
        filters.company === "" ||
        (template?.company?.clientName || "")
          .toLowerCase()
          .includes(filters.company.toLowerCase());
      
      const matchesLocation =
        filters.location === "" ||
        fullLocation
          .toLowerCase()
          .includes(filters.location.toLowerCase());
      
      const matchesName =
        filters.name === "" ||
        (template?.reportName || "")
          .toLowerCase()
          .includes(filters.name.toLowerCase());

      return matchesCompany && matchesLocation && matchesName;
    });

    // Apply sorting if sortField is set
    if (sortField) {
      const sorted = [...filteredTemplates].sort((a, b) => {
        let aValue, bValue;

        // Map sortField to template properties
        if (sortField === "companyName") {
          aValue = (a?.company?.clientName || "").toString().toLowerCase();
          bValue = (b?.company?.clientName || "").toString().toLowerCase();
        } else if (sortField === "companyLocation") {
          const aLocation = `${a?.company?.address || ""}, ${a?.company?.city || ""}, ${a?.company?.state || ""} ${a?.company?.zipCode || ""}`.trim();
          const bLocation = `${b?.company?.address || ""}, ${b?.company?.city || ""}, ${b?.company?.state || ""} ${b?.company?.zipCode || ""}`.trim();
          aValue = aLocation.toLowerCase();
          bValue = bLocation.toLowerCase();
        } else if (sortField === "template") {
          aValue = (a?.reportName || "").toString().toLowerCase();
          bValue = (b?.reportName || "").toString().toLowerCase();
        } else {
          aValue = (a[sortField] || "").toString().toLowerCase();
          bValue = (b[sortField] || "").toString().toLowerCase();
        }

        if (sortOrder === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else {
          return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
        }
      });
      setSortedTemplates(sorted);
    } else {
      setSortedTemplates(filteredTemplates);
    }
  }, [filters, templateList, sortField, sortOrder, activeTab]);

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };
  const handleSort = (field) => {
    if (sortField === field) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else if (sortOrder === "desc") {
        setSortOrder(null); // Reset to original order on third click
        setSortField(null);
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const toggleSortOrder = (header) => {
    const field = headerFieldMapping[header];
    if (field) {
      handleSort(field);
    }
  };

  const navigate = useNavigate();

  // const convertToRFC2822 = (ms) => {
  //   const date = new Date(ms);
  //   return date.toUTCString();
  // };

  // const handleDelete = async (templateId) => {
  //   const isConfirmed = window.confirm(
  //     "Are you sure you want to delete this report?"
  //   );
  //   if (!isConfirmed) {
  //     re
  // turn; // If user cancels, do nothing
  //   }

  //   let data = JSON.stringify({
  //     query: `mutation DeleteSecurityReport($templateId: ID!) {
  //   deleteSecurityReport(templateId: $templateId) {
  //     success
  //     status
  //     message
  //     data
  //     error
  //   }
  // }`,
  //     variables: {
  //       templateId: templateId,
  //     },
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${API_URL}/graphql`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       const data = response.data?.data?.deleteSecurityReport?.success;
  //       if (data) {
  //         fetchSecurityReports();
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const MultiDeleteHandler = async () => {
    setShowDeleteModal(true);
  };
  const handleConfirmDelete = async () => {
    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Deleting reports...");
      setLoadingDownloadDocument(true);
      // const result = await MultiDelete(selectExportDocumentIds)
      const result = await MultiTempDelete(selectExportDocumentIds);

      // console.log("MultiDeleteHandler", result);

      if (result?.success) {
        showAlert("Reports deleted successfully!", "success");
        fetchSecurityReports();
        // Optionally: Refresh the list or update the UI here
        // e.g., fetchData(), reset selection, etc.
      } else {
        showError(
          `Failed to delete reports. Reason: ${
            result?.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error deleting reports:", error);
      showError("An unexpected error occurred while deleting the reports.");
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setLoadingDownloadDocument(false);
      setShowDeleteModal(false);
    }
  };

  // =========================================================== DATE FILTER ===========================================================

  const ReStructureHandler = () => {
    setFromDate("");
    setToDate("");
    // The useEffect will automatically handle filtering when dates are cleared
  };

  console.log("sortedReports", sortedReports);

  // ----------------------EXPORT DOCUMENT MULTIPLE -------------------------------
  const [selectExportDocumentIds, setSelectExportDocumentIds] = useState([]);

  const [selectAllReports, setSelectAllReports] = useState([]);

  // Modal states
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRetrieveModal, setShowRetrieveModal] = useState(false);
  const [showTempDeleteModal, setShowTempDeleteModal] = useState(false);
  const [showPermDeleteModal, setShowPermDeleteModal] = useState(false);
  const [showMultiRestoreModal, setShowMultiRestoreModal] = useState(false);
  const [showMultiPermDeleteModal, setShowMultiPermDeleteModal] = useState(false);

  // Alert modal states
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("info");

  // Report ID for individual operations
  const [selectedReportId, setSelectedReportId] = useState("");

  // Helper functions for alerts
  const showAlert = (message, type = "info") => {
    setAlertMessage(message);
    setAlertType(type);
    setShowSuccessAlert(true);
  };

  const showError = (message) => {
    setAlertMessage(message);
    setShowErrorAlert(true);
  };

  console.log("firstCreateAt lastCreateAt", firstCreateAt, lastCreateAt);

  const InputHandleExportDocumentIds = (reportId) => {
    const isExist = selectExportDocumentIds.includes(reportId);

    // Helper function to validate date
    const isValidDate = (dateStr) => {
      if (!dateStr) return false;
      const date = new Date(dateStr);
      return !isNaN(date.getTime());
    };

    if (isExist) {
      // Remove report ID
      const removeReport = selectExportDocumentIds.filter(
        (item) => item !== reportId
      );
      setSelectExportDocumentIds(removeReport);

      // Update first and last createAt dates after removal
      const remainingReports = reportTemplates.filter(
        (report) =>
          removeReport.includes(report.id) && isValidDate(report.createdAt)
      );
      if (remainingReports.length > 0) {
        const sortedDates = remainingReports
          .map((report) => new Date(report.createdAt))
          .sort((a, b) => a - b);
        setFirstCreateAt(sortedDates[0].toISOString());
        setLastCreateAt(sortedDates[sortedDates.length - 1].toISOString());
      } else {
        // Clear dates if no valid reports remain
        setFirstCreateAt(null);
        setLastCreateAt(null);
      }
    } else {
      // Add report ID
      setSelectExportDocumentIds((prev) => [...prev, reportId]);

      // Find the report to get its createAt date
      const selectedReport = reportTemplates.find(
        (report) => report.id === reportId
      );
      console.log("selectedReport", selectedReport);
      if (!selectedReport || !isValidDate(selectedReport.createdAt)) {
        console.warn(`Invalid or missing createdAt for report ID: ${reportId}`);
        // Optionally, skip updating dates or handle differently
        return;
      }

      // Update first and last createdAt dates
      const allSelectedIds = [...selectExportDocumentIds, reportId];
      const selectedReports = reportTemplates.filter(
        (report) =>
          allSelectedIds.includes(report.id) && isValidDate(report.createdAt)
      );
      console.log("selectedReports", selectedReports);
      if (selectedReports.length > 0) {
        const sortedDates = selectedReports
          .map((report) => new Date(report.createdAt))
          .sort((a, b) => a - b);
        setFirstCreateAt(sortedDates[0].toISOString());
        setLastCreateAt(sortedDates[sortedDates.length - 1].toISOString());
        console.log("sortedDates", sortedDates);
      } else {
        // Set single report's date if it's the only valid one
        setFirstCreateAt(new Date(selectedReport.createdAt).toISOString());
        setLastCreateAt(new Date(selectedReport.createdAt).toISOString());
      }
    }
  };

  const docPayload = {
    generateType: "",
    blackAndWhite: "",
    orientation: "",
  };
  const [emailForm, setEmailForm] = useState({
    subject: "",
    text: "",
    to: "",
    cc: "",
    bcc: "",
  });
  const [savedDocumentConfig, setSavedDocumentConfig] = useState(docPayload);
  const [openDocumentConfigPopup, setOpenDocumentConfigPopup] = useState(false);
  const [loadingDownloadDocument, setLoadingDownloadDocument] = useState(false);
  const [loadingPdfDownload, setLoadingPdfDownload] = useState(false);

  // Gmail functionality state
  const [loadingGmailSendingDocument, setLoadingGmailSendingDocument] =
    useState(false);

  // Main loading states
  const [isLoadingReports, setIsLoadingReports] = useState(false);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);
  const [loadingIndividualActions, setLoadingIndividualActions] = useState({});

  // Global loading states
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);
  const [globalLoadingText, setGlobalLoadingText] = useState("");
  const [showTopScreenLoader, setShowTopScreenLoader] = useState(false);
  const [showGmailForm, setShowGmailForm] = useState(false);
  const [gmailForm, setGmailForm] = useState({
    subject: "",
    text: "",
    to: [],
    cc: [],
    bcc: [],
  });

  const closeExportDocumentModal = () => setOpenDocumentConfigPopup(false);

  const BulkPdfExportHandler = () => {
    setLoadingPdfDownload(true);

    const data = JSON.stringify({
      reportIds: selectExportDocumentIds,
      generateType: savedDocumentConfig?.generateType,
      orientation: savedDocumentConfig?.orientation,
      // blackAndWhite: savedDocumentConfig?.blackAndWhite !== "color",
      blackAndWhite:
        savedDocumentConfig?.blackAndWhite === "color" ? "false" : "true",
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      responseType: "arraybuffer",
      url: `${API_URL}/api/pdf/generate`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoadingPdfDownload(false);
        closeExportDocumentModal();
        setSelectExportDocumentIds([]);

        setSavedDocumentConfig(docPayload);

        const fileExtension =
          savedDocumentConfig?.generateType === "pdf" ? "pdf" : "xlsx";
        const contentType =
          savedDocumentConfig?.generateType === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        if (selectExportDocumentIds.length === 1) {
          const selectedReport = sortedReports.find(
            (item) => item.id === selectExportDocumentIds[0]
          );
          const selectedReportName = selectedReport?.template || "Report";
          const safeReportName = selectedReportName
            .replace(/[\\/:*?"<>|]/g, "-")
            .trim();
          const generatedDate = DocumentExportFormatDate(new Date());
          link.download = `${safeReportName}-${generatedDate}.${fileExtension}`;
        } else {
          const selectedDates = sortedReports
            .filter((item) => selectExportDocumentIds.includes(item.id))
            .map((item) => new Date(item?.createdAt))
            .filter((date) => !Number.isNaN(date.getTime()))
            .sort((a, b) => a - b);

          const fromDate =
            selectedDates.length > 0
              ? DocumentExportFormatDate(selectedDates[0])
              : DocumentExportFormatDate(new Date());
          const toDate =
            selectedDates.length > 0
              ? DocumentExportFormatDate(selectedDates[selectedDates.length - 1])
              : fromDate;

          link.download = `Report-${fromDate} through ${toDate}.${fileExtension}`;
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Export error:", error);
        setLoadingPdfDownload(false);
        setSavedDocumentConfig(docPayload);
        setSelectExportDocumentIds([]);
      });
  };

  console.log("selectExportDocumentIds", selectExportDocumentIds);
  const SendReportsOnMailHandler = () => {
    setLoadingDownloadDocument(true);

    const data = JSON.stringify({
      reportIds: selectExportDocumentIds,
      generateType: savedDocumentConfig?.generateType,
      orientation: savedDocumentConfig?.orientation,
      blackAndWhite:
        savedDocumentConfig?.blackAndWhite === "color" ? "false" : "true",
      subject: emailForm.subject,
      text: emailForm.text,
      to: emailForm.to,
      cc: emailForm.cc || "",
      bcc: emailForm.bcc || "",
      filename: emailForm.subject, // Use subject as filename
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      responseType: "arraybuffer",
      url: `${API_URL}/api/pdf/sendreport`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoadingDownloadDocument(false);
        closeExportDocumentModal();
        setSelectExportDocumentIds([]);
        setSavedDocumentConfig(docPayload);

        // Reset email form after successful send
        setEmailForm({
          subject: "",
          text: "",
          to: "",
          cc: "",
          bcc: "",
        });
      })
      .catch((error) => {
        console.error("Email send error:", error);
        setLoadingDownloadDocument(false);
        setSavedDocumentConfig(docPayload);
        setSelectExportDocumentIds([]);
      });
  };

  console.log("selectExportDocumentIds", selectExportDocumentIds);

  // Gmail functionality handlers
  const openGmailSendingDocumentModal = async () => {
    if (selectExportDocumentIds.length === 0) {
      showError("Please select at least one report to send.");
      return;
    }

    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Loading email data...");
      
      // Fetch email data from all selected reports
      const TOKEN = SavedUser?.token;
      const emailDataPromises = selectExportDocumentIds.map(async (reportId) => {
        try {
          const response = await axios.post(
            `${API_URL}/graphql`,
            {
              query: `mutation FetchGeneratedReportById { fetchGeneratedReportById(id: ${reportId}) { success data } }`,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: TOKEN,
              },
            }
          );

          const responseData = response.data?.data?.fetchGeneratedReportById;
          if (responseData?.success && responseData.data) {
            return responseData.data;
          }
          return null;
        } catch (error) {
          console.error(`Error fetching report ${reportId}:`, error);
          return null;
        }
      });

      const reportsData = await Promise.all(emailDataPromises);
      
      // Helper function to normalize and filter emails
      const normalizeEmails = (emails) => {
        if (!emails) return [];
        if (Array.isArray(emails)) {
          return emails
            .map(email => typeof email === 'string' ? email.trim() : String(email).trim())
            .filter(email => email && email.length > 0);
        }
        if (typeof emails === 'string') {
          return emails
            .split(',')
            .map(e => e.trim())
            .filter(Boolean);
        }
        return [];
      };
      
      // Combine email data from all reports
      const allToEmails = [];
      const allCcEmails = [];
      const allBccEmails = [];

      reportsData.forEach((reportData) => {
        if (!reportData || !reportData.email) return;

        const emailData = reportData.email;
        
        // Collect To emails only from explicit email config on the report/template
        const toEmails = normalizeEmails(emailData.to);
        if (toEmails.length > 0) {
          allToEmails.push(...toEmails);
        }

        // Collect CC emails
        const ccEmails = normalizeEmails(emailData.cc);
        if (ccEmails.length > 0) {
          allCcEmails.push(...ccEmails);
        }

        // Collect BCC emails
        const bccEmails = normalizeEmails(emailData.bcc);
        if (bccEmails.length > 0) {
          allBccEmails.push(...bccEmails);
        }
      });

      // Normalize emails to lowercase for comparison (but keep original case for display)
      const normalizeEmailForComparison = (email) => String(email).toLowerCase().trim();
      
      // Remove duplicates within each field first (case-insensitive)
      const seenToEmails = new Set();
      const uniqueToEmails = allToEmails.filter(email => {
        const normalized = normalizeEmailForComparison(email);
        if (seenToEmails.has(normalized)) return false;
        seenToEmails.add(normalized);
        return true;
      });

      const seenCcEmails = new Set();
      const uniqueCcEmails = allCcEmails.filter(email => {
        const normalized = normalizeEmailForComparison(email);
        if (seenCcEmails.has(normalized)) return false;
        seenCcEmails.add(normalized);
        return true;
      });

      const seenBccEmails = new Set();
      const uniqueBccEmails = allBccEmails.filter(email => {
        const normalized = normalizeEmailForComparison(email);
        if (seenBccEmails.has(normalized)) return false;
        seenBccEmails.add(normalized);
        return true;
      });

      // Remove emails from CC and BCC if they already exist in TO (priority: TO > CC > BCC)
      // Use case-insensitive comparison
      const finalToEmails = uniqueToEmails;
      const finalCcEmails = uniqueCcEmails.filter(email => {
        const normalized = normalizeEmailForComparison(email);
        return !seenToEmails.has(normalized);
      });
      const finalBccEmails = uniqueBccEmails.filter(email => {
        const normalized = normalizeEmailForComparison(email);
        return !seenToEmails.has(normalized) && !seenCcEmails.has(normalized);
      });

      setGmailForm((prev) => ({
        ...prev,
        to: finalToEmails.length > 0 ? finalToEmails : [],
        cc: finalCcEmails.length > 0 ? finalCcEmails : [],
        bcc: finalBccEmails.length > 0 ? finalBccEmails : [],
      }));

      setShowGmailForm(true);
    } catch (error) {
      console.error("Error fetching email data:", error);
      showError("Failed to load email data. Please try again.");
      // Still open the modal with empty form
      setShowGmailForm(true);
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
    }
  };
  const closeGmailSendingDocumentModal = () => setShowGmailForm(false);

  const SendReportsOnGmailHandler = () => {
    setIsGlobalLoading(true);
    setShowTopScreenLoader(true);
    setGlobalLoadingText("Sending reports...");
    setLoadingGmailSendingDocument(true);

    // Ensure to, cc, and bcc are arrays, then convert to strings if needed
    const toEmails = Array.isArray(gmailForm.to) 
      ? gmailForm.to 
      : gmailForm.to 
      ? (typeof gmailForm.to === 'string' ? gmailForm.to.split(',').map(e => e.trim()).filter(Boolean) : [gmailForm.to])
      : [];
    
    const ccEmails = Array.isArray(gmailForm.cc) 
      ? gmailForm.cc 
      : gmailForm.cc 
      ? (typeof gmailForm.cc === 'string' ? gmailForm.cc.split(',').map(e => e.trim()).filter(Boolean) : [gmailForm.cc])
      : [];
    
    const bccEmails = Array.isArray(gmailForm.bcc) 
      ? gmailForm.bcc 
      : gmailForm.bcc 
      ? (typeof gmailForm.bcc === 'string' ? gmailForm.bcc.split(',').map(e => e.trim()).filter(Boolean) : [gmailForm.bcc])
      : [];

    const data = JSON.stringify({
      reportIds: selectExportDocumentIds,
      generateType: "pdf",
      orientation: "portrait",
      blackAndWhite: "false",
      subject: gmailForm.subject,
      text: gmailForm.text,
      to: toEmails,
      cc: ccEmails,
      bcc: bccEmails,
      filename: gmailForm.subject, // Use subject as filename
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      responseType: "arraybuffer",
      url: `${API_URL}/api/pdf/sendreport`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    axios
      .request(config)
      .then((response) => {
        setIsGlobalLoading(false);
        setShowTopScreenLoader(false);
        setLoadingGmailSendingDocument(false);
        closeGmailSendingDocumentModal();
        setSelectExportDocumentIds([]);

        // Reset Gmail form after successful send
        setGmailForm({
          subject: "",
          text: "",
          to: [],
          cc: [],
          bcc: [],
        });

        showAlert("Reports sent successfully!", "success");
      })
      .catch((error) => {
        console.error("Gmail send error:", error);
        setIsGlobalLoading(false);
        setShowTopScreenLoader(false);
        setLoadingGmailSendingDocument(false);
        setSelectExportDocumentIds([]);
        showError("Failed to send reports via Gmail. Please try again.");
      });
  };

  const handleSignOut = () => {
    console.log("Signed out successfully");
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    window.location.href = "https://login.maximalsecurityservices.com/";
  };

  // Pagination handlers
  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      currentPage: page,
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setPagination(prev => ({
      ...prev,
      pageSize,
      currentPage: 1, // Reset to first page when changing page size
    }));
  };

  // Get paginated data
  const getPaginatedData = () => {
    const startIndex = (pagination.currentPage - 1) * pagination.pageSize;
    const endIndex = startIndex + pagination.pageSize;
    return sortedReports.slice(startIndex, endIndex);
  };

  // Get paginated template data
  const getPaginatedTemplateData = () => {
    const startIndex = (pagination.currentPage - 1) * pagination.pageSize;
    const endIndex = startIndex + pagination.pageSize;
    return sortedTemplates.slice(startIndex, endIndex);
  };

  const RetrieveReportHandler = async (reportId) => {
    setSelectedReportId(reportId);
    setShowRetrieveModal(true);
  };

  const handleConfirmRetrieve = async () => {
    const reportId = selectedReportId;

    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Restoring report...");
      const response = await RetrieveDeletedReportAPI(reportId);
      if (response?.success) {
        fetchSecurityReports();
        setSelectedReportId("");
        showAlert("Report restored successfully!", "success");
        console.log("Report restored successfully:", response);
      } else {
        showError(
          `Failed to restore report: ${response?.message || "Unknown error"}`
        );
        console.error("Failed to restore report:", response?.message);
      }
    } catch (error) {
      showError("An error occurred while restoring the report.");
      console.error("Error restoring report:", error);
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setShowRetrieveModal(false);
    }
  };

console.log("selectExportDocumentIds",selectExportDocumentIds.length,selectExportDocumentIds)


  const handleTemporaryDelete = async (reportId) => {
    setSelectedReportId(reportId);
    setShowTempDeleteModal(true);
  };

  const handleConfirmTempDelete = async () => {
    const reportId = selectedReportId;

    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Deleting report...");
      setLoadingIndividualActions((prev) => ({ ...prev, [reportId]: true }));
      const response = await TempDeleteAPI(reportId);
      console.log("responseresponse", response);
      if (response?.success) {
        fetchSecurityReports();
        setSelectedReportId("");
        showAlert("Report deleted successfully!", "success");
      } else {
        showError(
          `Failed to delete report: ${response?.message || "Unknown error"}`
        );
        console.error("Failed to delete report:", response?.message);
      }
    } catch (error) {
      showError("An error occurred while deleting the report.");
      console.error("Error deleting report:", error);
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setLoadingIndividualActions((prev) => ({ ...prev, [reportId]: false }));
      setShowTempDeleteModal(false);
    }
  };

  const handlePermanentDelete = async (templateId) => {
    setSelectedReportId(templateId);
    setShowPermDeleteModal(true);
  };

  const handleConfirmPermDelete = async () => {
    const templateId = selectedReportId;

    let data = JSON.stringify({
      query: `mutation DeleteSecurityReport($templateId: ID!) {
        deleteSecurityReport(templateId: $templateId) {
          success
          status
          message
          data
          error
        }
  }`,
      variables: {
        templateId: templateId,
      },
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_URL}/graphql`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Permanently deleting report...");
      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));
      const data = response.data?.data?.deleteSecurityReport?.success;
      if (data) {
        fetchSecurityReports();
        setSelectedReportId("");
        showAlert("Report permanently deleted successfully!", "success");
      } else {
        showError("Failed to permanently delete report.");
      }
    } catch (error) {
      showError("An error occurred while permanently deleting the report.");
      console.log(error);
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setShowPermDeleteModal(false);
    }
  };

  // Multiple restore handler
  const MultiRestoreHandler = () => {
    if (selectExportDocumentIds.length === 0) return;
    setShowMultiRestoreModal(true);
  };

  const handleConfirmMultiRestore = async () => {
    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Restoring reports...");
      setLoadingDownloadDocument(true);

      // Restore each report sequentially
      const restorePromises = selectExportDocumentIds.map((reportId) =>
        RetrieveDeletedReportAPI(reportId)
      );
      
      const results = await Promise.all(restorePromises);
      const successCount = results.filter((result) => result?.success).length;
      const failedCount = results.length - successCount;

      if (successCount > 0) {
        fetchSecurityReports();
        setSelectExportDocumentIds([]);
        if (failedCount === 0) {
          showAlert(
            `Successfully restored ${successCount} report(s)!`,
            "success"
          );
        } else {
          showAlert(
            `Restored ${successCount} report(s), ${failedCount} failed.`,
            "success"
          );
        }
      } else {
        showError("Failed to restore reports. Please try again.");
      }
    } catch (error) {
      console.error("Error restoring reports:", error);
      showError("An unexpected error occurred while restoring the reports.");
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setLoadingDownloadDocument(false);
      setShowMultiRestoreModal(false);
    }
  };

  // Multiple permanent delete handler
  const MultiPermDeleteHandler = () => {
    if (selectExportDocumentIds.length === 0) return;
    setShowMultiPermDeleteModal(true);
  };

  const handleConfirmMultiPermDelete = async () => {
    try {
      setIsGlobalLoading(true);
      setShowTopScreenLoader(true);
      setGlobalLoadingText("Permanently deleting reports...");
      setLoadingDownloadDocument(true);

      const result = await MultiDelete(selectExportDocumentIds);

      if (result?.success) {
        fetchSecurityReports();
        setSelectExportDocumentIds([]);
        showAlert("Reports permanently deleted successfully!", "success");
      } else {
        showError(
          `Failed to permanently delete reports. Reason: ${
            result?.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error permanently deleting reports:", error);
      showError(
        "An unexpected error occurred while permanently deleting the reports."
      );
    } finally {
      setIsGlobalLoading(false);
      setShowTopScreenLoader(false);
      setLoadingDownloadDocument(false);
      setShowMultiPermDeleteModal(false);
    }
  };

  // useEffect(() => {
  //   if (
  //     activeTab === "retrieve" &&
  //     selectExportDocumentIds &&
  //     selectExportDocumentIds.length !== 0
  //   ) {
  //     setSelectExportDocumentIds([]);
  //   }
  //   else if (activeTab === "repr" &&
  //     selectExportDocumentIds &&
  //     selectExportDocumentIds.length !== 0){
  //     setSelectExportDocumentIds([]);

  //     }
  // }, [activeTab]);


  // console.log("selectExportDocumentIds",selectExportDocu`mentIds ? selectExportDocumentIds :"==>")
  return (
    <div className={`w-full text-sm h-full   ${PixelStyle} `}>
      {/* Global Top Screen Loader */}
      <TopScreenLoader
        isVisible={showTopScreenLoader}
        text={globalLoadingText}
        showText={true}
      />

      {/* Global Top Bar Loader */}
      {/* <GlobalLoader 
        isVisible={isLoadingReports || isLoadingTemplates} 
        text={isLoadingReports ? "Loading reports..." : "Loading templates..."}
        showText={true}
      /> */}
      {openDocumentConfigPopup && (
        <CardPopModel
          isOpen={openDocumentConfigPopup}
          onClose={closeExportDocumentModal}
          title="Configure Export"
          size="sm"
        >
          <DocumentConfigurator
            savedDocumentConfig={savedDocumentConfig}
            setSavedDocumentConfig={setSavedDocumentConfig}
            finishExportDocument={BulkPdfExportHandler}
            loading={loadingPdfDownload}
            emailForm={emailForm}
            setEmailForm={setEmailForm}
            onSendEmail={SendReportsOnMailHandler}
            lastCreateAt={lastCreateAt}
            firstCreateAt={firstCreateAt}
            selectExportDocumentIds={selectExportDocumentIds}
            
          />
        </CardPopModel>
      )}

      <div className="flex justify-between items-center my-6">
        {/* <HeaderContainer pageTitle="Reporting">
          <span className="text-black">Reporting</span>
        </HeaderContainer> */}
        <div>
          <h1 className="text-3xl font-bold text-[#004175]">Reporting</h1>
          <p className="text-gray-600">Manage your security reports</p>
        </div>
        <div>
          <Button
            variant="outline"
            onClick={handleSignOut}
            className="text-red-600 border-red-600 hover:bg-red-50"
          >
            Log out
          </Button>
        </div>
      </div>

      {/* <div className='w-full flex gap-3'>
        <div className='w-full flex   justify-between gap-3 lg:gap-10 bg-white shadow p-3 rounded-lg'>
          <div className='flex lg:flex-row flex-col lg:items-center  text-sm  gap-3 w-full'>
            <div className='flex items-center justify-between gap-3 w-full'>
              <div className='relative w-full'>
                <Input
                  className='w-[85%]'
                  type='text'
                  placeholder='Client Name'
                  value={clientName}
                  onChange={(e) => {
                    setClientName(e.target.value);
                    setOpenSearchBarClientName(
                      e.target.value === "" ? false : true
                    );
                  }}
                />
                {openSearchBarClientName && filterClientName.length > 0 && (
                  <ul className='absolute p-3 z-10 w-full mt-1 border border-gray-300 rounded bg-white shadow-lg max-h-52 overflow-y-auto'>
                    {filterClientName.map((client) => (
                      <li
                        key={client.id}
                        className='p-2 border-b hover:bg-gray-200 cursor-pointer'
                        onClick={() => {
                          setClientName(client.clientName);
                          setSelectedClientNameId(client.id);
                          setOpenSearchBarClientName(false);
                          setFilterClientName([]); // Clear the dropdown after selection
                        }}
                      >
                        {client.clientName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className='relative w-full'>
                <input
                  type='text'
                  placeholder='Search Report Template'
                  className='w-full p-2 border rounded shadow-sm outline-none'
                  value={searchTemplate}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchTemplate(value);
                    if (value) {
                      setTemplateSearchTerm(value);
                      setShowTemplateDropdown(true);
                    } else {
                      setShowTemplateDropdown(false);
                    }
                  }}
                />
                {showTemplateDropdown && (
                  <ul className='absolute p-3 z-10 w-full mt-1 border border-gray-300 rounded bg-white shadow-lg max-h-52 overflow-y-auto assignReportScroll'>
                    {SearchfilteredTemplates.length > 0 ? (
                      SearchfilteredTemplates.map(
                        (template) =>
                          template.name && (
                            <li
                              key={template.id}
                              className='p-2 border-b hover:bg-gray-200 cursor-pointer flex items-center gap-3'
                              onClick={() =>
                                handleSelect(
                                  template.id,
                                  template.name,
                                  template.companyLocation
                                )
                              }
                            >
                              <div className='flex flex-col'>
                                <span className=' text-base font-semibold'>
                                  {template.name && template.name}
                                </span>
                                <span className=' flex '>
                                  <span className=''>
                                    {template.companyName}{" "}
                                  </span>
                                </span>
                                <span className='text-zinc-400 '>
                                  {template.companyLocation &&
                                    template.companyLocation}
                                </span>
                              </div>
                            </li>
                          )
                      )
                    ) : (
                      <li className='p-2 text-gray-500'>No templates found</li>
                    )}
                  </ul>
                )}
              </div>

              <Input
                className='w-full'
                type='text'
                value={showReportData?.companyLocation}
                placeholder='Address'
                disabled
              />
              <Input className='w-[75%]' type='date' placeholder='Date From' />
              <Input className='w-[75%]' type='date' placeholder='Date to' />
            </div>
          </div>
        </div>
        <div className='bg-white shadow p-3 rounded-lg text-nowrap flex items-center'>
          <button
            className=' p-2 lg:px-10 px-5 rounded-md bg-blue-500 text-white '
            // onClick={handleUpdateReportTemplate}
          >
            Filter
          </button>
        </div>
      </div> */}

      <div className="mt-3">
        {/* Header Section */}
        <div className="flex justify-between items-center w-full mb-2 ml-3">
          {/* Tab Headers */}
          <div className="flex gap-4 ">
            <TabButton
              isActive={activeTab === "active"}
              onClick={() => setActiveTab("active")}
            >
              Active Reports
            </TabButton>
            <TabButton
              isActive={activeTab === "submitted"}
              onClick={() => setActiveTab("submitted")}
            >
              Submitted Reports
            </TabButton>
            <TabButton
              isActive={activeTab === "retrieve"}
              onClick={() => setActiveTab("retrieve")}
            >
              Deleted Reports
            </TabButton>
            <TabButton
              isActive={activeTab === "templates"}
              onClick={() => setActiveTab("templates")}
            >
              Templates
            </TabButton>
          </div>

          {/* Tab Content */}
          {/* <div className="mt-4">
                {activeTab === "reports" && renderReportsContent()}
                {activeTab === "retrieve" && renderRetrieveContent()}
              </div> */}

          {/* <button
              className='text-zinc-500 p-2 rounded flex items-center gap-2'
              // onClick={() => ExportToExcel(ExportPayload(reportTemplates))}
            >
              <GoDownload className='text-2xl' />
            </button> */}
          <div className="flex items-center space-x-2 mx-4">
            <div className="flex items-center space-x-2 text-nowraps">
              {(activeTab === "active" || activeTab === "submitted") && (
                <button
                  style={{ border: "1px solid #004278" }}
                  disabled={
                    selectExportDocumentIds.length === 0 ||
                    loadingDownloadDocument
                  }
                  className={`border py-1.5 px-2 rounded-md font-normal ${
                    selectExportDocumentIds.length === 0 ||
                    loadingDownloadDocument
                      ? "border-gray-300 text-zinc-400"
                      : " border-red-400"
                  }`}
                  onClick={MultiDeleteHandler}
                >
                  {loadingDownloadDocument ? (
                    <ButtonLoader size="sm" />
                  ) : (
                    <Trash size={14} />
                  )}
                </button>
              )}
              {activeTab === "retrieve" && (
                <>
                  <button
                    style={{ border: "1px solid #004278" }}
                    disabled={
                      selectExportDocumentIds.length === 0 ||
                      loadingDownloadDocument
                    }
                    className={`border py-1.5 px-2 rounded-md font-normal ${
                      selectExportDocumentIds.length === 0 ||
                      loadingDownloadDocument
                        ? "border-gray-300 text-zinc-400"
                        : "border-green-400 text-green-600"
                    }`}
                    onClick={MultiRestoreHandler}
                    title="Restore Selected"
                  >
                    {loadingDownloadDocument ? (
                      <ButtonLoader size="sm" />
                    ) : (
                      <VscDebugRestartFrame size={14} />
                    )}
                  </button>
                  <button
                    style={{ border: "1px solid #004278" }}
                    disabled={
                      selectExportDocumentIds.length === 0 ||
                      loadingDownloadDocument
                    }
                    className={`border py-1.5 px-2 rounded-md font-normal ${
                      selectExportDocumentIds.length === 0 ||
                      loadingDownloadDocument
                        ? "border-gray-300 text-zinc-400"
                        : "border-red-400 text-red-600"
                    }`}
                    onClick={MultiPermDeleteHandler}
                    title="Permanently Delete Selected"
                  >
                    {loadingDownloadDocument ? (
                      <ButtonLoader size="sm" />
                    ) : (
                      <Trash size={14} />
                    )}
                  </button>
                </>
              )}
              {activeTab !== "retrieve" && (
                <>
                  <button
                    style={{ border: "1px solid #004278" }}
                    disabled={selectExportDocumentIds.length === 0}
                    className={`border py-1.5 px-2 rounded-md font-normal border-red-400 ${
                      selectExportDocumentIds.length === 0 &&
                      "border-gray-300 text-zinc-400"
                    }`}
                    onClick={openGmailSendingDocumentModal}
                    title="Send"
                  >
                    <SiGmail size={14} />
                  </button>
                  <button
                    style={{ border: "1px solid #004278" }}
                    disabled={selectExportDocumentIds.length === 0}
                    className={`border p-1 px-2 rounded-md font-normal  border-blue-400 ${
                      selectExportDocumentIds.length === 0 &&
                      "border-gray-300 text-zinc-400"
                    }`}
                    onClick={() => setOpenDocumentConfigPopup(true)}
                  >
                    {/* Export */}
                    <FileUp size={20} />
                    {/* <Icon icon="file-up" /> */}
                  </button>
                </>
              )}
            </div>

            <div className="flex items-center space-x-2">
              {/* <div> */}
              <input
                style={{ border: "1px solid #004278" }}
                name={"createdAt"}
                value={fromDate}
                type="date"
                onChange={(e) => setFromDate(e.target.value)}
                className="border p-1 px-2 rounded-md font-normal outline-blue-500"
              />
              <input
                style={{ border: "1px solid #004278" }}
                name={"createdAt"}
                value={toDate}
                type="date"
                onChange={(e) => setToDate(e.target.value)}
                className="border p-1 px-2 rounded-md font-normal outline-blue-500"
              />
              {/* </div> */}
              {(fromDate || toDate) && (
                <button
                  onClick={ReStructureHandler}
                  className="bg-blue-100 border border-blue-200 p-1 rounded px-3"
                >
                  Clear
                </button>
              )}
            </div>
          </div>
        </div>

        <div className=" bg-white rounded-2xl rounded-b-none overflow-hidden shadow-2xl">
        <div className="relative overflow-x-auto bg-white w-full rounded-2xl max-h-[70vh] overflow-y-auto">
        <table className="w-full text-left">
              <thead>
                <tr className="bg-[#004278] text-white font-semibold text-nowrap sticky top-0 z-20">
                  {TableHead.map((item, index) => (
                    <th
                      scope="col"
                      className={`px-3 py-2 text-sm ${
                        item === "checkbox"
                          ? "w-12"
                          : item === "status"
                          ? "w-24"
                          : item === "createdAt"
                          ? "w-32"
                          : ""
                      }`}
                      key={index}
                    >
                      <div
                        className={`flex items-center justify-between gap-1.5 ${
                          headerFieldMapping[item] ? "cursor-pointer" : ""
                        }`}
                        onClick={() =>
                          headerFieldMapping[item] && toggleSortOrder(item)
                        }
                      >
                        <span className="flex items-center gap-1.5">
                          {item === "checkbox" ? (
                            <div className="flex items-center gap-2">
                              <div className="flex items-center">
                                <input
                                  classname='flex'
                                  type="checkbox"
                                  checked={
                                    sortedReports.length > 0 &&
                                    sortedReports.every((item) =>
                                      activeTab === "retrieve"
                                        ? selectExportDocumentIds.includes(
                                            item.id
                                          ) && item?.isDeleted
                                        : selectExportDocumentIds.includes(
                                            item.id
                                          ) && !item?.isDeleted
                                    )
                                  }
                                  onChange={() => {
                                    const allIds = sortedReports.map(
                                      (item) => item.id
                                    );
                                    const areAllSelected = allIds.every((id) =>
                                      selectExportDocumentIds.includes(id)
                                    );

                                    if (areAllSelected) {
                                      // Deselect all
                                      const updatedIds =
                                        selectExportDocumentIds.filter(
                                          (id) => !allIds.includes(id)
                                        );
                                      setSelectExportDocumentIds(updatedIds);

                                      // Also update dates if needed
                                      const remainingReports =
                                        reportTemplates.filter(
                                          (report) =>
                                            updatedIds.includes(report.id) &&
                                            new Date(
                                              report.createdAt
                                            ).toString() !== "Invalid Date"
                                        );
                                      if (remainingReports.length > 0) {
                                        const sortedDates = remainingReports
                                          .map((r) => new Date(r.createdAt))
                                          .sort((a, b) => a - b);
                                        setFirstCreateAt(
                                          sortedDates[0].toISOString()
                                        );
                                        setLastCreateAt(
                                          sortedDates[
                                            sortedDates.length - 1
                                          ].toISOString()
                                        );
                                      } else {
                                        setFirstCreateAt(null);
                                        setLastCreateAt(null);
                                      }
                                    } else {
                                      // Select all
                                      const newIds = Array.from(
                                        new Set([
                                          ...selectExportDocumentIds,
                                          ...allIds,
                                        ])
                                      );
                                      setSelectExportDocumentIds(newIds);

                                      // Also update dates
                                      const selectedReports =
                                        reportTemplates.filter(
                                          (report) =>
                                            newIds.includes(report.id) &&
                                            new Date(
                                              report.createdAt
                                            ).toString() !== "Invalid Date"
                                        );
                                      if (selectedReports.length > 0) {
                                        const sortedDates = selectedReports
                                          .map((r) => new Date(r.createdAt))
                                          .sort((a, b) => a - b);
                                        setFirstCreateAt(
                                          sortedDates[0].toISOString()
                                        );
                                        setLastCreateAt(
                                          sortedDates[
                                            sortedDates.length - 1
                                          ].toISOString()
                                        );
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              {item}
                              {headerFieldMapping[item] && (
                                <div className="flex flex-col text-xs">
                                  <IoCaretUp
                                    className={`-mb-1 ${
                                      sortField === headerFieldMapping[item] &&
                                      sortOrder === "asc"
                                        ? "text-white"
                                        : "text-blue-200"
                                    }`}
                                  />
                                  <IoCaretDown
                                    className={`${
                                      sortField === headerFieldMapping[item] &&
                                      sortOrder === "desc"
                                        ? "text-white"
                                        : "text-blue-200"
                                    }`}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </span>
                      </div>
                    </th>
                  ))}
                </tr>
                <tr className="sticky top-9 z-10 bg-white shadow-[0_1px_0_0_#000] [&>th]:bg-white">
                  {[
                    "checkbox",
                    ...(activeTab !== "templates" ? ["actions"] : []),
                    "company",
                    "location",
                    "name",
                    "createdAt",
                    ...(activeTab === "submitted" ? ["Submitted by"] : []),
                    ...(activeTab === "submitted" ? ["Time submitted"] : []),
                    ...(activeTab === "retrieve" ? ["Deleted By"] : []),
                    ...(activeTab === "retrieve" ? ["Deleted At"] : []),
                    ...(activeTab === "templates" ? ["actions"] : []),
                  ]
                    .filter((header) => {
                      if (activeTab === "templates") {
                        return ![
                          "checkbox",
                          "createdAt",
                          "date created",
                      
                          // "Status/Security",
                          // "Status/Management",
                          "Action",
                        ].includes(header);
                      }
                      return true;
                    })
                    .map((header, index) =>
                      header === "" ? (
                        ""
                      ) : header === "checkbox" ? (
                        <th scope="col" className="px-3 gap-2 bg-white">
                          {/* <div className="flex items-center">
                        <input
                          type="checkbox"
                          checked={
                            sortedReports.length > 0 &&
                            sortedReports.every((item) =>
                              activeTab === "retrieve"
                                ? selectExportDocumentIds.includes(item.id) &&
                                  item?.isDeleted
                                : selectExportDocumentIds.includes(item.id) &&
                                  !item?.isDeleted
                            )
                          }
                          onChange={() => {
                            const allIds = sortedReports.map((item) => item.id);
                            const areAllSelected = allIds.every((id) =>
                              selectExportDocumentIds.includes(id)
                            );

                            if (areAllSelected) {
                              // Deselect all
                              const updatedIds = selectExportDocumentIds.filter(
                                (id) => !allIds.includes(id)
                              );
                              setSelectExportDocumentIds(updatedIds);

                              // Also update dates if needed
                              const remainingReports = reportTemplates.filter(
                                (report) =>
                                  updatedIds.includes(report.id) &&
                                  new Date(report.createdAt).toString() !== "Invalid Date"
                              );
                              if (remainingReports.length > 0) {
                                const sortedDates = remainingReports
                                  .map((r) => new Date(r.createdAt))
                                  .sort((a, b) => a - b);
                                setFirstCreateAt(sortedDates[0].toISOString());
                                setLastCreateAt(
                                  sortedDates[
                                    sortedDates.length - 1
                                  ].toISOString()
                                );
                              } else {
                                setFirstCreateAt(null);
                                setLastCreateAt(null);
                              }
                            } else {
                              // Select all
                              const newIds = Array.from(
                                new Set([...selectExportDocumentIds, ...allIds])
                              );
                              setSelectExportDocumentIds(newIds);

                              // Also update dates
                              const selectedReports = reportTemplates.filter(
                                (report) =>
                                  newIds.includes(report.id) &&
                                  new Date(report.createdAt).toString() !== "Invalid Date"
                              );
                              if (selectedReports.length > 0) {
                                const sortedDates = selectedReports
                                  .map((r) => new Date(r.createdAt))
                                  .sort((a, b) => a - b);
                                setFirstCreateAt(sortedDates[0].toISOString());
                                setLastCreateAt(
                                  sortedDates[
                                    sortedDates.length - 1
                                  ].toISOString()
                                );
                              }
                            }
                          }}
                        />
                      </div> */}
                        </th>
                      ) : header === "createdAt" ||
                        header === "Submitted by" ||
                        header === "Time submitted" ? (
                        <th
                          scope="col"
                          className="px-3 py-2 bg-white"
                          key={index}
                        >
                          {/* <input
                      name={header}
                      value={fromDate}
                      type="date"
                      onChange={(e) => setFromDate(e.target.value)}
                      className="border p-1 px-2 rounded-md font-normal outline-blue-500"
                    />
                    <input
                      name={header}
                      value={toDate}
                      type="date"
                      onChange={(e) => setToDate(e.target.value)}
                      className="border p-1 px-2 rounded-md font-normal outline-blue-500"
                    /> */}
                        </th>
                      ) : header === "actions" ? (
                        <th className="bg-white"></th>
                      ) : (
                        <th scope="col" className="px-3 py-2 bg-white" key={index}>
                          <input
                                    style={{ border: "1px solid #64646453" }}
                                    
                            placeholder={`Search ${
                              header === "name"
                                ? "report name"
                                : header === "company"
                                ? "client name"
                                : header === "location"
                                ? "client location"
                                : header === "createdAt"
                                ? "date created"
                                : header === "status"
                                ? "status"
                                : header === "isSubmitted"
                                ? "status/security"
                                : header === "Submitted At"
                                ? "Date Submitted"
                                : header === "isSubmittedByManagement"
                                ? "status/management"
                                : header === "Deleted By" || header === "deletedBy"
                                ? "deleted by"
                                : header === "Deleted At" || header === "deletedAt"
                                ? "deleted at"
                                : header
                            }`}
                            type={`${
                              header === "Submitted At" ? "date" : "text"
                            }`}
                            name={
                              header === "Deleted By" ? "deletedBy" :
                              header === "Deleted At" ? "deletedAt" :
                              header
                            }
                            value={
                              header === "Deleted By" ? filters.deletedBy :
                              header === "Deleted At" ? filters.deletedAt :
                              filters[header] || ""
                            }
                            onChange={handleFilterChange}
                            className=" border border-gray-300 p-1 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </th>
                      )
                    )}
                </tr>
              </thead>
              <tbody>
                {activeTab === "templates" ? (
                  sortedTemplates && sortedTemplates.length > 0 ? (
                    getPaginatedTemplateData().map((template, index) => {
                      // const company = template?.company?.industry;
                      // console.log("Template clicked");
                      return (
                        <Tr
                          key={index}
                          className="flex-nowrap cursor-pointer hover:bg-gray-50"
                          onClick={() =>
                            console.log("Template clicked", template?.id)
                          }
                        >
                          {/* {process.env.REACT_APP_ENV === "development" && (
                      <Td>{template?.id}</Td>
                    )} */}
                          {activeTab !== "templates" && (
                            <Td className="">
                              <input type="checkbox" disabled />
                            </Td>
                          )}
                          <Td
                            className="max-w-32 truncate"
                            title={template?.company?.clientName}
                          >
                            {template?.company?.clientName}
                          </Td>
                          <Td
                            className="max-w-48 truncate"
                            title={`${template?.company?.address}, ${template?.company?.city}, ${template?.company?.state} ${template?.company?.zipCode}`}
                          >{`${template?.company?.address}, ${template?.company?.city}, ${template?.company?.state} ${template?.company?.zipCode}`}</Td>
                          <Td
                            className="font-medium max-w-xs truncate"
                            title={template?.reportName}
                          >
                            {template?.reportName}
                          </Td>
                          {activeTab === "templates" ? (
                            <Td>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTemplateClick(template.id);
                                }}
                                className="bg-blue-50 border border-blue-100 text-blue-600 p-1 px-3 hover:bg-blue-500 hover:text-white rounded-md"
                              >
                                Create Report
                              </button>
                            </Td>
                          ) : (
                            <>
                              <Td className="text-nowrap">N/A</Td>
                              <Td>{template.status}</Td>
                              <Td>N/A</Td>
                              <Td className="">
                                <div className="text-lg flex gap-1">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleTemplateClick(template.id);
                                    }}
                                    className="hover:text-blue-500 hover:bg-blue-100 p-1.5 rounded-lg"
                                    title="Create Report"
                                  >
                                    <FiEdit3 />
                                  </button>
                                </div>
                              </Td>
                            </>
                          )}
                        </Tr>
                      );
                    })
                  ) : (
                    <Tr>
                      <Td
                        colSpan="8"
                        className="text-center py-4 text-gray-500"
                      >
                        No templates found
                      </Td>
                    </Tr>
                  )
                ) : sortedReports && sortedReports.length > 0 ? (
                  getPaginatedData().map((item, index) => {
                    // Calculate the actual index in the full dataset
                    const actualIndex = (pagination.currentPage - 1) * pagination.pageSize + index;

                    console.log(" item?.submittedAt", item?.submittedAt);
                    return (
                      <Tr key={actualIndex} className="flex-nowrap  ">
                        {/* {process.env.REACT_APP_ENV === "development" && (
                      <Td>{item?.id}</Td>
                      )} */}

                        <Td>
                          <span className="flex justify-center items-center">

                          <input
                            type="checkbox"
                            checked={selectExportDocumentIds.includes(
                              item?.id
                            )}
                            onChange={() =>
                              InputHandleExportDocumentIds(item?.id)
                            }
                            />
                            </span>
                        </Td>
                        <Td className="">
                          <div className="text-lg flex gap-1">
                            {/* <NavLink to={(`/report/${item.id}`)}> */}
                            {activeTab === "retrieve" && (
                              <button
                                onClick={() => RetrieveReportHandler(item.id)}
                                className="hover:text-green-600 hover:bg-green-100 p-1.5 rounded-lg"
                              >
                                <VscDebugRestartFrame />
                              </button>
                            )}
                            <button
                              onClick={() =>
                                window.open(`/report/${item.id}`)
                              }
                              className="hover:text-blue-500 hover:bg-blue-100 p-1.5 rounded-lg"
                            >
                              {/* <IoEyeOffOutline /> */}
                              <Eye size={16} />
                            </button>
                            {/* </NavLink> */}

                            <button
                              className="hover:text-red-500 text-red-500 hover:bg-red-100 p-1.5 rounded-lg disabled:opacity-50"
                              disabled={loadingIndividualActions[item?.id]}
                              onClick={() => {
                                if (activeTab === "active" || activeTab === "submitted") {
                                  handleTemporaryDelete(item?.id);
                                } else {
                                  handlePermanentDelete(item?.id);
                                }
                              }}
                            >
                              {loadingIndividualActions[item?.id] ? (
                                <ButtonLoader size="sm" />
                              ) : (
                                <Trash size={16} />
                              )}
                            </button>
                          </div>
                        </Td>
                        <Td
                          className="max-w-32 truncate"
                          title={item?.companyName}
                        >
                          {item?.companyName}
                        </Td>
                        <Td
                          className="max-w-48 truncate"
                          title={item?.companyLocation}
                        >
                          {item?.companyLocation}
                        </Td>
                        <Td
                          className="max-w-xs truncate"
                          title={item?.template}
                        >
                          {item?.template}
                        </Td>
                        <Td className="text-nowrap w-32">
                          {item?.createdAt && formattedDate(item.createdAt)}
                        </Td>
                     {activeTab === "submitted" &&   <Td className="text-nowrap w-32">
                          {item?.securityName}
                        </Td>}
                        {activeTab === "submitted" && (
                          <Td>
                            {item?.submittedAt &&
                              formattedDate(item.submittedAt)}
                          </Td>
                        )}
                        {/* <Td>
                      {selectedReportId !== item?.id ? (
                        item?.isSubmitted ? (
                          "Submitted"
                        ) : (
                          "Not Submitted"
                        )
                      ) : (
                        <InlineLoader />
                      )}
                    </Td>
                    <Td>
                      {selectedReportId !== item?.id ? (
                        item?.isSubmittedByManagement ? (
                          "Submitted"
                        ) : (
                          "Not Submitted"
                        )
                      ) : (
                        <InlineLoader />
                      )}
                    </Td> */}
                        {activeTab === "retrieve" && item?.deletedBy && (
                          <Td>
                            {item?.deletedBy}
                          </Td>
                        )}
                        {activeTab === "retrieve" && item?.deletedAt && (
                          <Td>
                            {formattedDate(item?.deletedAt)}
                          </Td>
                        )}
                      </Tr>
                    );
                  })
                ) : (
                  ""
                )}
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          
        </div>
      </div>
      {((activeTab === "templates" && sortedTemplates && sortedTemplates.length > 0) || 
            (activeTab === "retrieve" && sortedReports && sortedReports.length > 0) ||
            (activeTab !== "templates" && activeTab !== "retrieve" && sortedReports && sortedReports.length > 0)) && (
            <div className="flex justify-end mt-4 ">
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={Math.ceil(pagination.totalItems / pagination.pageSize)}
                pageSize={pagination.pageSize}
                totalItems={pagination.totalItems}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                pageSizeOptions={[10, 25, 50, 100]}
                className="justify-end"
              />
            </div>
          )}

      {/* Gmail Modal */}
      <EmailFormModal
        showEmailForm={showGmailForm}
        setShowEmailForm={setShowGmailForm}
        emailForm={gmailForm}
        setEmailForm={setGmailForm}
        onSendEmail={SendReportsOnGmailHandler}
        loading={loadingGmailSendingDocument}
        // For Gmail sending, only use explicit email data from reports.
        // If there is no email config on the report/template, leave the "To" field empty.
        defaultEmail=""
        reportName={
          selectExportDocumentIds.length === 1
            ? (() => {
                const selectedReport = sortedReports.find(
                  (item) => item.id === selectExportDocumentIds[0]
                );
                return selectedReport?.template || "Security Report";
              })()
            : "Security Reports"
        }
        currentDate={
          selectExportDocumentIds.length === 1
            ? (() => {
                const selectedReport = sortedReports.find(
                  (item) => item.id === selectExportDocumentIds[0]
                );
                return selectedReport?.createdAt
                  ? moment(selectedReport.createdAt).format("MM/DD/YYYY")
                  : moment().format("MM/DD/YYYY");
              })()
            : firstCreateAt && lastCreateAt
            ? `${moment(firstCreateAt).format("MM/DD/YYYY")} through ${moment(
                lastCreateAt
              ).format("MM/DD/YYYY")}`
            : moment().format("MM/DD/YYYY")
        }
      />

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedReportId("");
        }}
        onConfirm={handleConfirmDelete}
        title="Delete Reports"
        message="Are you sure you want to delete this report?"
        confirmText="Confirm"
        cancelText="Close"
        confirmVariant="danger"
      />

      {/* Retrieve Confirmation Modal */}
      <ConfirmationModal
        isOpen={showRetrieveModal}
        onClose={() => {
          setShowRetrieveModal(false);
          setSelectedReportId("");
        }}
        onConfirm={handleConfirmRetrieve}
        title="Restore Report"
        message="Are you sure you want to restore this report?"
        confirmText="Confirm"
        cancelText="Close"
        confirmVariant="primary"
      />

      {/* Temporary Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showTempDeleteModal}
        onClose={() => {
          setShowTempDeleteModal(false);
          setSelectedReportId("");
        }}
        onConfirm={handleConfirmTempDelete}
        title="Delete Report"
        message="Are you sure you want to delete this report?"
        confirmText="Confirm"
        cancelText="Close"
        confirmVariant="danger"
      />

      {/* Permanent Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showPermDeleteModal}
        onClose={() => {
          setShowPermDeleteModal(false);
          setSelectedReportId("");
        }}
        onConfirm={handleConfirmPermDelete}
        title="Permanently Delete Report"
        message="Are you sure you want to permanently delete this report? This action cannot be undone."
        confirmText="Confirm"
        cancelText="Close"
        confirmVariant="danger"
      />

      {/* Multiple Restore Confirmation Modal */}
      <ConfirmationModal
        isOpen={showMultiRestoreModal}
        onClose={() => {
          setShowMultiRestoreModal(false);
        }}
        onConfirm={handleConfirmMultiRestore}
        title="Restore Reports"
        message={`Are you sure you want to restore ${selectExportDocumentIds.length} selected report(s)?`}
        confirmText="Confirm"
        cancelText="Close"
        confirmVariant="primary"
      />

      {/* Multiple Permanent Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showMultiPermDeleteModal}
        onClose={() => {
          setShowMultiPermDeleteModal(false);
        }}
        onConfirm={handleConfirmMultiPermDelete}
        title="Permanently Delete Reports"
        message={`Are you sure you want to permanently delete ${selectExportDocumentIds.length} selected report(s)? This action cannot be undone.`}
        confirmText="Confirm"
        cancelText="Close"
        confirmVariant="danger"
      />

      {/* Success Alert Modal */}
      <AlertModal
        isOpen={showSuccessAlert}
        onClose={() => setShowSuccessAlert(false)}
        title="Success"
        message={alertMessage}
        type="success"
        buttonText="OK"
      />

      {/* Error Alert Modal */}
      <AlertModal
        isOpen={showErrorAlert}
        onClose={() => setShowErrorAlert(false)}
        title="Error"
        message={alertMessage}
        type="error"
        buttonText="OK"
      />
    </div>
  );
};

export default ManagementReport;

// export const DocumentConfigurator = ({
//   savedDocumentConfig,
//   setSavedDocumentConfig,
//   finishExportDocument,
//   loading,
// }) => {
//   const [currentStep, setCurrentStep] = useState("generateType");
//   const [isExcelSaved, setIsExcelSaved] = useState(false);

//   const steps = [
//     { key: "generateType", label: "Select Document Type" },
//     { key: "blackAndWhite", label: "Select Color Mode" },
//     { key: "orientation", label: "Select Orientation" },
//   ];

//   const handleSelection = (stepKey, title) => {
//     setSavedDocumentConfig((prev) => ({
//       ...prev,
//       [stepKey]: title,
//     }));

//     const isExcel = title === "excel";

//     if (!isExcel) {
//       setIsExcelSaved(false);
//       const currentIndex = steps.findIndex((step) => step.key === stepKey);
//       if (currentIndex < steps.length - 1) {
//         setCurrentStep(steps[currentIndex + 1].key);
//       }
//     } else setIsExcelSaved(true);
//   };

//   const isStepComplete = (stepKey) => {
//     return savedDocumentConfig[stepKey] !== "";
//   };

//   const handleEmailChange = (e) => {
//     setEmailForm((prev) => ({
//       ...prev,
//       [e.target.name]: e.target.value,
//     }));
//   };

//   return (
//     <div className="p-4">
//       <div className="mb-6">
//         {steps.map((step, index) => (
//           <div key={step.key} className="flex items-center mb-2">
//             <div
//               className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 ${
//                 isStepComplete(step.key)
//                   ? "bg-blue-600 text-white"
//                   : currentStep === step.key
//                   ? "bg-blue-200"
//                   : "bg-gray-200"
//               } ${isExcelSaved && step.key !== "generateType" && "opacity-0"}`}
//             >
//               {index + 1}
//             </div>
//             <span
//               className={`${currentStep === step.key ? "font-semibold" : ""} ${
//                 isExcelSaved && step.key !== "generateType" && "opacity-0"
//               }`}
//             >
//               {step.label}
//             </span>
//             {isStepComplete(step.key) && (
//               <span
//                 className={`ml-2 text-blue-600   ${
//                   isExcelSaved && step.key !== "generateType"
//                     ? "opacity-0"
//                     : savedDocumentConfig[step.key] === "pdf"
//                     ? "uppercase"
//                     : "capitalize"
//                 }`}
//               >
//                 ({savedDocumentConfig[step.key]})
//               </span>
//             )}
//           </div>
//         ))}
//       </div>

//       <div className="space-y-3">
//         <h3 className="text-lg font-semibold">
//           {steps.find((step) => step.key === currentStep).label}
//         </h3>
//         {DocumentConfig[currentStep].map(
//           (item, index) =>
//             item.title !== "excel" && (
//               <button
//                 key={`${item.id}-${index}`}
//                 onClick={() => handleSelection(currentStep, item.title)}
//                 className={`
//               w-full p-3 rounded-md border text-left
//               ${
//                 savedDocumentConfig[currentStep] === item.title
//                   ? "border-blue-600 bg-blue-50 text-blue-800"
//                   : "border-gray-200 hover:border-blue-600 hover:bg-blue-50 hover:text-blue-800"
//               }

//               ${item.title === "pdf" ? "uppercase" : "capitalize"}
//             `}
//               >
//                 {item.title}
//               </button>
//             )
//         )}
//       </div>

//       <div className="mt-6 flex justify-between">
//         <button
//           onClick={() => {
//             const currentIndex = steps.findIndex(
//               (step) => step.key === currentStep
//             );
//             if (currentIndex > 0) {
//               setCurrentStep(steps[currentIndex - 1].key);
//             }
//           }}
//           disabled={steps.findIndex((step) => step.key === currentStep) === 0}
//           className="px-4 py-2 bg-gray-200 rounded-md disabled:opacity-50"
//         >
//           Previous
//         </button>
//         {(isStepComplete("orientation") ||
//           savedDocumentConfig?.generateType === "excel") && (
//           <div className="flex gap-2">
//             <button
//               onClick={() => {
//                 setShowEmailForm(true);
//               }}
//               className="px-4 py-2 bg-green-600 text-white rounded-md"
//               disabled={loading}
//             >
//               E-mail
//             </button>
//             <button
//               onClick={() => {
//                 finishExportDocument();
//                 setCurrentStep("generateType");
//               }}
//               disabled={loading}
//               className="px-4 py-2 bg-blue-600 text-white rounded-md"
//             >
//               {loading ? (
//                 <LoaderCircle className="animate-spin w-6 h-6 text-white" />
//               ) : (
//                 "Finish"
//               )}
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Email Form Modal */}
//       {showEmailForm && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded-md w-full max-w-md shadow-lg relative">
//             <button
//               className="absolute top-2 right-4 text-gray-500"
//               onClick={() => setShowEmailForm(false)}
//             >
//               ×
//             </button>
//             <h3 className="text-lg font-semibold mb-4">Send E-mail</h3>
//             <div className="space-y-3">
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   To
//                   <input
//                     type="email"
//                     name="to"
//                     value={emailForm.to}
//                     onChange={handleEmailChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md p-2"
//                     placeholder="Recipient e-mail"
//                   />
//                 </label>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Subject
//                   <input
//                     type="text"
//                     name="subject"
//                     value={emailForm.subject}
//                     onChange={handleEmailChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md p-2"
//                     placeholder="Email Subject"
//                   />
//                 </label>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-1">
//                   Body
//                   <textarea
//                     name="text"
//                     value={emailForm.text}
//                     onChange={handleEmailChange}
//                     className="mt-1 block w-full border border-gray-300 rounded-md p-2"
//                     placeholder="Message"
//                     rows={4}
//                   />
//                 </label>
//               </div>
//               <button
//                 onClick={onSendEmail}
//                 disabled={
//                   !emailForm.to ||
//                   !emailForm.subject ||
//                   !emailForm.text ||
//                   loading
//                 }
//                 className="w-full px-4 py-2 bg-blue-600 text-white rounded-md flex justify-center items-center"
//               >
//                 {loading ? (
//                   <LoaderCircle className="animate-spin w-6 h-6 text-white mr-2" />
//                 ) : (
//                   "Send"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

export const DocumentConfigurator = ({
  savedDocumentConfig,
  setSavedDocumentConfig,
  finishExportDocument,
  loading,
  emailForm,
  setEmailForm,
  onSendEmail,
  firstCreateAt,
  lastCreateAt,selectExportDocumentIds
}) => {
  const location = useLocation();
  const CURRENT_URL = location.pathname;
  const [showEmailForm, setShowEmailForm] = useState(false);

  console.table(CURRENT_URL, savedDocumentConfig);

  const handleSelection = (stepKey, title) => {
    setSavedDocumentConfig((prev) => ({
      ...prev,
      [stepKey]: title,
    }));
  };

  const isStepComplete = (stepKey) => {
    return savedDocumentConfig[stepKey] !== "";
  };

  return (
    <>
      <div className="p-6 space-y-6">
        {/* File Format */}
        <div className="space-y-3">
          <div className="flex gap-3">
            <button
              onClick={() => handleSelection("generateType", "pdf")}
              className={`py-3 px-6 rounded-md font-medium transition-colors w-full ${
                savedDocumentConfig.generateType === "pdf"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              PDF
            </button>
           { selectExportDocumentIds.length === 1 && <button
              onClick={() => handleSelection("generateType", "excel")}
              className={`py-3 px-6 rounded-md font-medium transition-colors w-full ${
                savedDocumentConfig.generateType === "excel"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              Excel
            </button>}
          </div>
        </div>

        {/* Color Settings */}
       {savedDocumentConfig.generateType === "pdf" && <div className="space-y-3">
          <div className="flex gap-3">
              <button
                onClick={() => handleSelection("blackAndWhite", "blackAndWhite")}
                className={`py-3 px-6 rounded-md font-medium transition-colors w-full ${
                  savedDocumentConfig.blackAndWhite === "blackAndWhite"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Black & White
              </button>
              <button
                onClick={() => handleSelection("blackAndWhite", "color")}
                className={`py-3 px-6 rounded-md font-medium transition-colors w-full ${
                  savedDocumentConfig.blackAndWhite === "color"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Color
              </button>
          </div>
        </div>}

        {/* Page Orientation */}
        {savedDocumentConfig.generateType === "pdf" &&<div className="space-y-3">
          <div className="flex gap-3">
              <button
                onClick={() => handleSelection("orientation", "landscape")}
                className={`py-3 px-6 rounded-md font-medium transition-colors w-full ${
                  savedDocumentConfig.orientation === "landscape"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Landscape
              </button>
              <button
                onClick={() => handleSelection("orientation", "portrait")}
                className={`py-3 px-6 rounded-md font-medium transition-colors w-full ${
                  savedDocumentConfig.orientation === "portrait"
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Portrait
              </button>
          </div>
        </div>}

        {/* Download Button */}
        <div className="flex justify-center pt-4 border-t">
          <button
            onClick={() => {
              finishExportDocument();
            }}
            disabled={ 
              loading ||
              !isStepComplete("generateType") ||
              savedDocumentConfig.generateType === "pdf" ? !isStepComplete("blackAndWhite") : false ||
              savedDocumentConfig.generateType === "pdf" ? !isStepComplete("orientation") : false
            }
            className="px-8 py-3 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <LoaderCircle className="animate-spin w-5 h-5" />
                Downloading...
              </div>
            ) : (
              "Download"
            )}
          </button>
        </div>
      </div>

      {/* Email Form Modal */}
      <EmailFormModal
        showEmailForm={showEmailForm}
        setShowEmailForm={setShowEmailForm}
        emailForm={emailForm}
        setEmailForm={setEmailForm}
        onSendEmail={onSendEmail}
        loading={loading}
        defaultEmail="securityEmail"
        reportName="Security Reporting"
        currentDate={
          firstCreateAt && lastCreateAt
            ? `${moment(firstCreateAt).format("MM-DD-YYYY")} through ${moment(
                lastCreateAt
              ).format("MM-DD-YYYY")}`
            : moment().format("MM-DD-YYYY")
        }
      />
    </>
  );
};
